import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useStore } from '../store/store';
import { paths } from '../utils/constants/routes';
import { HEADER_MESSAGE_TYPES } from '../utils/constants/header';

const useAppSessionGuard = () => {
  const { authStore, utilsStore } = useStore();
  const navigate = useNavigate();
  useEffect(() => {
    if (utilsStore.isSessionExpired) {
      const wasLoggedIn = !!authStore.user;
      utilsStore.setIsSessionExpired(false);
      authStore.logout();
      navigate(paths.HOME);
      if (wasLoggedIn) {
        utilsStore.setHeaderMessage(
          'Your session has expired. Please login again.',
          HEADER_MESSAGE_TYPES.ERROR
        );
      }
    }
  }, [utilsStore.isSessionExpired]);
};

export default useAppSessionGuard;
